import React from 'react'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useTitle from '../../../elements/Hooks/useTitle'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'
import Salaries from '../../../components/People/Salaries/Salaries'
import {SalariesApi} from '../../../api/People/Salaries'

function SalariesCont() {
  const {list: cached, fetching, fetch} = useFetchList(() => SalariesApi.list())
  const {list, company, onChangeCompany} = useListCompanyFilter(
    cached,
    fetching,
  )

  useTitle('Salaries')

  return (
    <Salaries
      {...{
        list,
        fetching,
        fetch,
        company,
        onChangeCompany,
      }}
    />
  )
}

SalariesCont.propTypes = {}
SalariesCont.defaultProps = {}

export default SalariesCont
